export default __webpack_public_path__ + "952f7c8f7d05dc778d3f86aeb47349ba.png";